module.exports = __webpack_public_path__ + "assets/img/Logo_火狐.34649887.svg";